var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ActiveTab__Header"},[_c('div',{staticClass:"ActiveTab__Eyebrow"},[_vm._v(" Locatie ID: "+_vm._s(`${_vm.chargingpoint.data.code}-${_vm.chargingpoint.data.properties.id}`)+" "),_c('img',{staticClass:"ActiveTab__Eyebrow__Icon",attrs:{"src":_vm.legendIcon,"width":"15","alt":""}})]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }